import React, { createContext, useContext, useState } from 'react';

const SettingsFormContext = createContext(null);

export const SettingsFormProvider = ({ children }) => {
  const [isDirty, setIsDirty] = useState(false);

  return (
    <SettingsFormContext.Provider value={{ isDirty, setIsDirty }}>
      {children}
    </SettingsFormContext.Provider>
  );
};

export const useSettingsForm = () => {
  const ctx = useContext(SettingsFormContext);
  if (!ctx) {
    return { isDirty: false, setIsDirty: () => {} };
  }
  return ctx;
};
